import { createFileRoute } from "@tanstack/react-router";
import { InvitePage } from "@/features/auth/invite-page";

export const Route = createFileRoute("/invite/$token")({
  component: InvitePage,
});
